export default __webpack_public_path__ + "static/media/sigma-barrier.94cc5bd4.mp3";